// @ts-nocheck


import { classesRuntime, statesRuntime } from "../../../stylable-esm-runtime.js";



var _namespace_ = "CharactersLimitInput2299291232";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st: import("@stylable/runtime").STFunction = _style_;

export var namespace = _namespace_;
export var classes = {"root":"CharactersLimitInput2299291232__root","field":"CharactersLimitInput2299291232__field"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




